import { useQuery } from '@tanstack/react-query';
import brandMetricsApi from '../api/brandMetrics';

export const brandMetricsQueryKeys = {
  brands: ['brandMetrics', 'brands'],
  panel: (brandId, start, end) => ['brandMetrics', 'panel', String(brandId), start, end],
  myPanel: (start, end) => ['brandMetrics', 'my-panel', start, end],
  overview: (start, end) => ['brandMetrics', 'overview', start, end],
  campaigns: (brandId, start, end) =>
    ['brandMetrics', 'campaigns', String(brandId), start, end],
  myCampaigns: (start, end) => ['brandMetrics', 'my-campaigns', start, end],
  catalog: (brandId, start, end) => ['brandMetrics', 'catalog', String(brandId), start, end],
  myCatalog: (start, end) => ['brandMetrics', 'my-catalog', start, end],
};

const STALE_MS = 5 * 60 * 1000; // los datos se sincronizan 2 veces por día

export function useConfiguredBrandsQuery(options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.brands,
    queryFn: async () => {
      const data = await brandMetricsApi.getConfiguredBrands();
      return data?.brands ?? [];
    },
    staleTime: STALE_MS,
    ...options,
  });
}

export function useBrandPanelQuery(brandId, start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.panel(brandId, start, end),
    queryFn: () => brandMetricsApi.getBrandPanel(brandId, start, end),
    enabled: Boolean(brandId && start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useMyBrandPanelQuery(start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.myPanel(start, end),
    queryFn: () => brandMetricsApi.getMyPanel(start, end),
    enabled: Boolean(start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useBrandCampaignsQuery(brandId, start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.campaigns(brandId, start, end),
    queryFn: () => brandMetricsApi.getBrandCampaigns(brandId, start, end),
    enabled: Boolean(brandId && start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useMyCampaignsQuery(start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.myCampaigns(start, end),
    queryFn: () => brandMetricsApi.getMyCampaigns(start, end),
    enabled: Boolean(start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useBrandCatalogQuery(brandId, start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.catalog(brandId, start, end),
    queryFn: () => brandMetricsApi.getBrandCatalog(brandId, start, end),
    enabled: Boolean(brandId && start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useMyCatalogQuery(start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.myCatalog(start, end),
    queryFn: () => brandMetricsApi.getMyCatalog(start, end),
    enabled: Boolean(start && end),
    staleTime: STALE_MS,
    ...options,
  });
}

export function useBrandsOverviewQuery(start, end, options = {}) {
  return useQuery({
    queryKey: brandMetricsQueryKeys.overview(start, end),
    queryFn: async () => {
      const data = await brandMetricsApi.getBrandsOverview(start, end);
      return data?.rows ?? [];
    },
    enabled: Boolean(start && end),
    staleTime: STALE_MS,
    ...options,
  });
}
